import {Service, IHttpResponse} from './Service';
import store from '../Store';

export class AuthenticatedService extends Service {
  private getToken = () => {
    const {auth: {token: {accessToken}}} = store.getState();
    return accessToken;
  }

  public getAuth = async <T>(
    path: string,
    json: boolean = true,
  ): Promise<IHttpResponse<T>> => {
    return await this.get(`${this.config.BaseUrl}/${path}`, {
      'Authorization': `Bearer ${this.getToken()}`,
    }, json);
  }

  public postAuth = async <T>(
    path: string,
    body: any,
  ): Promise<IHttpResponse<T>> => {
    return await this.post(`${this.config.BaseUrl}/${path}`,
      body, {
        'Authorization': `Bearer ${this.getToken()}`,
      });
  }

  public postFormAuth = async <T>(
    path: string,
    body: any,
  ): Promise<IHttpResponse<T>> => {
    return await this.postForm(`${this.config.BaseUrl}/${path}`,
      body, {
        'Authorization': `Bearer ${this.getToken()}`,
      });
  }

  public putAuth = async <T>(
    path: string,
    body: any,
  ): Promise<IHttpResponse<T>> => {
    return await this.put(`${this.config.BaseUrl}/${path}`,
      body, {
        'Authorization': `Bearer ${this.getToken()}`,
      });
  }

  public putFormAuth = async <T>(
    path: string,
    body: any,
  ): Promise<IHttpResponse<T>> => {
    return await this.putForm(`${this.config.BaseUrl}/${path}`,
      body, {
        'Authorization': `Bearer ${this.getToken()}`,
      });
  }

  public deleteAuth = async <T>(
    path: string,
    json: boolean = true,
  ): Promise<IHttpResponse<T>> => {
    return await this.delete(`${this.config.BaseUrl}/${path}`, {
      'Authorization': `Bearer ${this.getToken()}`,
    }, json);
  }
}

